import React, { Component } from 'react';
import Config from '../Config'
import moment from 'moment';
import CheckItem from '../components/CheckItem';

class Status extends Component {
    constructor(props) {
        super(props);

        this.state = {
            mode: "process",
            tasks: [],
            data: null
        };
    }

    componentDidMount() {
        this.updateStatus();
    }

    componentWillUnmount() {
        clearTimeout(this.ts);
    }

    updateStatus() {

        fetch(Config.DigibonServiceBase + 'process/' + this.props.id, Config.GetBearer())
            .then((res) => { return res.ok ? res.json() : { status: res.status } })
            .then(data => {
                if (data.status === 401) {
                    console.log("Token expired");
                    return;
                }

                if (data.processedDate === null) {
                    // not complete yet, refresh
                    this.setState({ data: data, tasks: data.tasks });
                    this.ts = setTimeout(() => {
                        var el = document.getElementById("status_" + this.props.id);
                        if (el) {

                            this.updateStatus();
                        }
                    }, 3000);       // refresh in three seconds
                } else {
                    // process complete
                    const newTasks = [...data.tasks, { description: "Proces is voltooid", completeDate: data.processedDate }];
                    this.setState({ mode: "", data: data, tasks: newTasks });
                }
            })
            .catch((error) => {
                this.setState({ mode: "" });
            });

    }
    headerClick(e) {
        if (e.ctrlKey) {
            console.log("process", this.props.process);
            console.log("changes", this.props.process.changes);
        }
    }

    restart(item) {
        fetch(Config.DigibonServiceBase + 'process/' + this.props.id + "/restarttask/" + item.code, Config.GetBearer())
        .then((res) => { return res.ok ? "Taak is herstart" : "Er is een fout opgetreden" })
        .then((msg) => alert (msg));
    }

    render() {

        const uid = "status_" + this.props.id;

        // the id was added to check if this element should still be refreshed when switching tabs
        return <div id={uid} onClick={this.headerClick.bind(this)}>

            {this.state.processId && this.state.data === null && <div>
                Nog geen gegevens bekend
            </div>
            }
            {this.state.data !== null && <div>
                <div>Aangemaakt: {moment(this.state.data.createDate).format('DD-MM-YYYY HH:mm')}</div>
                {
                    this.state.tasks.map((item, idx) => {

                        var description = item.description;
                        if (item.completeDate) {
                            description += " (" + moment(item.completeDate).format('HH:mm') + ")"
                        }
                        return <div className="row" key={idx + this.state.mode}>
                            <div className="col"><CheckItem value={item.completeDate} label={description} mode={this.state.mode}></CheckItem></div>
                            {this.props.isAdmin &&
                                <div className="col">
                                    <span className="link btn-primary" onClick={p => this.restart(item)} >restart</span>
                                </div>
                            }

                        </div>
                    })
                }
            </div>
            }
        </div>
    }
}

export default Status;